import { LoadingParams } from 'framework/list';
import { COMPLIANCE_DOCUMENT_STATUS, ComplianceDocumentType, ComplianceDocumentTypeFE } from 'domain/shared/compliance';
import { ProjectData } from 'domain/shared/newProject';
import { ProjectPoliciesData, ProjectPolicyListItem } from './types';

const PUBLISHED_DOCUMENT_FILTER = {
  status: {
    eq: COMPLIANCE_DOCUMENT_STATUS.PUBLISHED,
  },
} as const;

type PolicyTargetFilter = {
  relatedEmployeeProjectIds?: { in: string[] };
  relatedEmployeeAccountIds?: { in: string[] };
};

export const buildDocumentFilter = (params: LoadingParams, targetFilter: PolicyTargetFilter) => ({
  ...(params.filter || {}),
  ...PUBLISHED_DOCUMENT_FILTER,
  ...targetFilter,
});

export const mergeDocumentsById = (
  projectDocuments: ComplianceDocumentType[] = [],
  accountDocuments: ComplianceDocumentType[] = [],
) => Array.from(new Map([...projectDocuments, ...accountDocuments].map(item => [item.id, item])).values());

export const mapProjectPoliciesDocument = (
  document: ComplianceDocumentTypeFE,
  context: ProjectPoliciesData,
): ProjectPolicyListItem => {
  const currentProjectAssignments = document.metadata.assignments?.length ? [context.currentProjectAssignment] : [];

  return {
    ...document,
    currentProjectCoverageAssignments: currentProjectAssignments,
    currentProjectViewAssignments: currentProjectAssignments,
  };
};

const getProjectLegacyId = (project: ProjectData) => String(project.legacyId ?? project.id);

export const buildProjectPoliciesData = (project: ProjectData): ProjectPoliciesData => {
  const projectLegacyId = getProjectLegacyId(project);
  const currentProjectName = project.name || '';

  return {
    projectLegacyId,
    currentAccountId: project.accountData?.accountId ? String(project.accountData.accountId) : null,
    currentAccountName: project.accountData?.accountName || null,
    currentProjectName,
    currentProjectAssignment: {
      id: projectLegacyId,
      name: currentProjectName || projectLegacyId,
      account: false,
    },
  };
};
